import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { CONFIG } from '../../../../config'
import { getUsuarioInfo } from '../../../localstorage/localstorage.service'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/registration`
const user = getUsuarioInfo()

const LeadTimeRecebimentoCargaHttp = {
  async getLeadTime(centralId, empresaId) {
    try {
      const url =
        BASE_URL +
        `/lead-time-recebimento-carga?central_id=${centralId}&empresa_id=${empresaId}&user_id=${user.id}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async salvarLeadTime(leadsTime) {
    try {
      const url = BASE_URL + `/lead-time-recebimento-carga/${user.id}`
      const response = await authHttp().post(url, leadsTime)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
}

export default LeadTimeRecebimentoCargaHttp
